<template>
  <div :class="`alert alert-${type} p-3 d-flex align-items-center w-100`">
    <img src="/images/icons/triangle.svg" alt="triangle" v-if="type == 'warning' || type == 'danger'">
    <img src="/images/icons/success.svg" alt="triangle" v-if="type == 'success'">
    <img src="/images/icons/info.svg" alt="triangle" v-if="type == 'info'">

    <div class="ms-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type"],
};
</script>
